import React, { useEffect, useRef, useState } from 'react';
import { Button, Form, Modal, Alert, Spinner } from 'react-bootstrap';
import { uploadPdf } from '../Services/api';

const UploadModel = ({ Show, Hide, size = 'md', onUploaded }) => {
    const [file, setFile] = useState(null);
    const [msg, setMsg] = useState({ err: '', ok: '' });
    const [uploading, setUploading] = useState(false);
    const ctrlRef = useRef(null);
    const inputRef = useRef(null);

    useEffect(() => {
        setFile(null);
        setMsg({ err: '', ok: '' });
        if (inputRef.current) inputRef.current.value = '';
        if (!Show && ctrlRef.current) {
            ctrlRef.current.abort();
            ctrlRef.current = null;
        }
    }, [Show]);

    const handleFileChange = ({ target }) => {
        setMsg({ err: '', ok: '' });
        const f = target.files?.[0];
        if (!f || f.type !== 'application/pdf') {
            setFile(null);
            setMsg({ err: 'Please select a PDF file (.pdf).', ok: '' });
            if (inputRef.current) inputRef.current.value = '';
            return;
        }
        setFile(f);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMsg({ err: '', ok: '' });
        if (!file) return setMsg({ err: 'Please choose a PDF first.', ok: '' });

        setUploading(true);
        const ctrl = new AbortController();
        ctrlRef.current = ctrl;

        try {
            const res = await uploadPdf(file, ctrl.signal);
            setMsg({ err: '', ok: res?.message || 'Uploaded successfully.' });
            onUploaded?.(res);
        } catch (ex) {
            if (ex.name !== 'AbortError') setMsg({ err: ex.message || 'Failed to upload.', ok: '' });
        } finally {
            setUploading(false);
            ctrlRef.current = null;
        }
    };

    return (
        <Modal show={Show} onHide={Hide} size={size} backdrop="static" keyboard={false}>
            <Modal.Header className="d-flex justify-content-between align-items-center modal_closeButton">
                <Modal.Title>Upload Pdf</Modal.Title>
                <div className="close_modal text-danger fw-bold" onClick={Hide} title="Close" style={{ cursor: 'pointer' }}>X</div>
            </Modal.Header>

            <Modal.Body>
                {msg.err && <Alert variant="danger" className="mb-3">{msg.err}</Alert>}
                {msg.ok && <Alert variant="success" className="mb-3">{msg.ok}</Alert>}

                <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="formFile" className="mb-3">
                        <Form.Label className="fs-15 fw-bold">
                            Upload Your Pdf File <span className="text-danger fw-bold fs-13">*</span>
                        </Form.Label>
                        <Form.Control
                            ref={inputRef}
                            type="file"
                            accept="application/pdf"
                            className="chatBox_inputBox p-2"
                            onChange={handleFileChange}
                            disabled={uploading}
                        />
                    </Form.Group>

                    <div className="text-end">
                        <Button variant="dark" type="submit" disabled={uploading}>
                            {uploading ? (<><Spinner size="sm" className="me-2" />Uploading…</>) : 'Submit'}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default UploadModel;

